import React, { useContext } from "react";
import { FaFlask, FaExclamationTriangle, FaBook, FaRecycle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./chem2.jpg";

const Chemical: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/chemical-safety');
    } else {
      navigate('/login', { state: { from: '/booking/chemical-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Hazardous Materials</span>
          <h1 className="hero-title">Chemical Safety</h1>
          <p className="hero-subtitle">
            From acids to solvents, understand the invisible risks.
            Master GHS labels, MSDS/SDS interpretation, and proper handling procedures.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Know Your Chemicals</h2>
              <p className="article-text">
                Not all hazards are visible. Molecular stability, flammability limits, and toxicity levels
                determine how a substance reacts. Training focuses on recognizing these properties before
                uncapping the bottle.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The GHS System</h2>
              <p className="article-text">
                The Globally Harmonized System (GHS) creates a universal language for safety.
                <ul style={{ paddingLeft: '20px', color: '#ccc', marginTop: '10px', lineHeight: '1.8' }}>
                  <li><strong>Health Hazard:</strong> Carcinogens, respiratory sensitizers.</li>
                  <li><strong>Flame:</strong> Flammables, pyrophorics.</li>
                  <li><strong>Exclamation Mark:</strong> Irritants, skin sensitizers.</li>
                  <li><strong>Corrosion:</strong> Skin burns, eye damage.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">MSDS / SDS</h2>
              <p className="article-text">
                The Safety Data Sheet (SDS) is the chemical's "User Manual." It contains 16 critical sections
                including First Aid actions, Firefighting measures, and accidental release protocols.
                <strong>Rule #1:</strong> Read the SDS <em>before</em> using the chemical.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Safe Storage</h2>
              <p className="article-text">
                Incompatible chemicals can cause explosions. Acids must be separated from Bases.
                Oxidizers must be kept away from Flammables. Secondary containment trays prevent spills
                from reaching drains.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Chemical Pillars</h4>
              <ul className="key-list">
                <li><FaFlask className="check-icon" /> Handling & Transfer</li>
                <li><FaBook className="check-icon" /> SDS Management</li>
                <li><FaExclamationTriangle className="check-icon" /> Spill Response</li>
                <li><FaRecycle className="check-icon" /> Waste Disposal</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Did You Know?</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                A simple mixture of Bleach and Ammonia creates Chloramine gas, which can be deadly.
                Never mix chemicals without authorization.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Safety First</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Master chemical safety today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Chemical;
